<div class="modal-sm">
  <div class="earn-transfer">
    <div class="otpsub">
      <div class="head">
        <div style="text-align: center">
          <img
            itemprop="image"
            class="logo logo-dark mt-x1"
            alt="CoinZoom Exchange"
            src="./assets/image/icons/logo_white.svg"
            width="200"
          />
        </div>
        <span>
          <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal()">X</button>
        </span>
      </div>

      <div class="transfer-details">
        @if (saving) {
          <div class="loader_wallet_crypto">
            <cz-spinner></cz-spinner>
          </div>
        }

        <form
          class="custom-form"
          (ngSubmit)="onTransfer()"
          method="post"
          name="signUPForm"
          autocomplete="off"
          [formGroup]="transferFormGroup"
        >
          <div class="row title-row">
            @if (toEarn && !showAgreement) {
              <span>Invest {{ currency.id }} to earn interest</span>
            }
            @if (!toEarn && !showAgreement) {
              <span>Redeem {{ currency.id }} from your earn wallet</span>
            }
            @if (showAgreement) {
              <span
                >To participate in the CoinZoom earn program you must read and accept the terms of CoinZoom's Master Loan Agreement. The
                details can be found <a class="embedded-web-link mla-link" [href]="agreementUrl" target="_blank">here</a></span
              >
            }
          </div>
          <div class="row" [hidden]="!showAgreement">
            <div class="form-group col-sm-3"></div>
            <div class="form-group col-sm-9">
              <label class="checkbox-div"
                >Accept agreement
                <input type="checkbox" name="acceptAgreement" formControlName="acceptAgreement" />
                <span class="checkmark"></span>
              </label>
              @if (transferFormGroup?.errors?.agreementRequired && transferFormGroup.controls.acceptAgreement.touched) {
                <div class="alert alert-danger alert-accept">You must accept the agreement.</div>
              }
            </div>
          </div>
          <div class="row" [hidden]="showAgreement">
            <div class="form-group col-md-12">
              <input
                type="number"
                class="form-control"
                name="amount"
                formControlName="amount"
                [placeholder]="placeholder"
                czNoNumericSpin
                (keydown)="onlyNumericAllowed($event)"
              />
              @if (transferFormGroup.controls.amount.invalid && transferFormGroup.controls.amount.touched) {
                <div class="alert alert-danger">
                  @if (transferFormGroup.controls.amount.errors?.required) {
                    <div>A value is required</div>
                  }
                  @if (transferFormGroup.controls.amount.errors?.maxTransfer) {
                    <div>Max is <cz-currency-amount [amount]="maxPossibleTransfer" [currency]="currency"></cz-currency-amount></div>
                  }
                  @if (transferFormGroup.controls.amount.errors?.precision) {
                    <div>No more that {{ currency.minorUnitsQty }} decimals</div>
                  }
                </div>
              }
            </div>
          </div>
          @if (currency?.id !== usdCurrency?.id && !showAgreement) {
            <div class="row usd-equivalent">
              <div class="usd-container">
                $<cz-currency-amount [amount]="usdEquivalent" [currency]="usdCurrency"></cz-currency-amount> USD
              </div>
            </div>
          }
          @if (!showAgreement) {
            <div class="row move-all-row">
              @if (toEarn && rate.ledgerType === LedgerType.STAKING && rate.stakingHoldHours !== null) {
                <div class="hold-warning">Staked {{ currency.id }} cannot be withdrawn for {{ formattedHoldHours }}.</div>
              }
              @if (maxPossibleTransfer) {
                <div class="percent-wrapper">
                  <div id="collateral-all-percent" class="percent-in-wrapper" (click)="moveAll()">
                    @if (toEarn) {
                      <span>Invest All</span>
                    }
                    @if (!toEarn) {
                      <span>Redeem All</span>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (toEarn && !showAgreement) {
            <div class="row interest-row">
              <div class="interest-container">
                <label>Estimated annual interest</label>
                <div class="available-in-coin">
                  <cz-currency-amount [amount]="interest" [currency]="currency"></cz-currency-amount>
                  {{ currency.id }}
                </div>
                @if (interestBonus) {
                  <div class="bonus-interest">
                    + <cz-currency-amount [amount]="interestBonus" [currency]="zoomCurrency"></cz-currency-amount>
                    ZOOM bonus
                  </div>
                }
              </div>
            </div>
          }
          <div class="row ctrl-row">
            <button type="submit" class="btn btn-success" [disabled]="saving">Submit</button>
            <button type="button" class="btn btn-danger" (click)="hideModal()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
